import React from 'react';
import { ListSortContextValue } from './types';

export const ListSortContext = React.createContext<ListSortContextValue | null>(null);

export function useListSortContext(): ListSortContextValue {
    const context = React.useContext(ListSortContext);
    if (!context) {
        throw new Error('useListSortContext must be used within a List');
    }
    return context;
}
